import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const GeneralExcess = (props) => {
  return (
    <FormGroup controlId="generalExcess">
      <Col componentClass={ControlLabel} sm={5}>
        General Excess (HKD)
      </Col>
      <Col sm={7}>
          <FormControl
            type="text"
            maxLength="60"
            autoComplete="off"
            value={props.generalExcess}
            onChange={props.handleChangeGeneralExcess}
          />
      </Col>
    </FormGroup>
  )
}

GeneralExcess.propTypes = {
  generalExcess: PropTypes.string,
  handleChangeGeneralExcess: PropTypes.func
};

export default GeneralExcess;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/generalExcess/GeneralExcess.js